// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"84620cad","438":"89621ad8","441":"89549e9c","545":"d31a736e","664":"b4aefc13"}[chunkId] + ".chunk.js";
};